import { theme } from '@acorns/grove'
import { Page as BasePage } from '@acorns/web-components'
import styled from 'styled-components'

export const Page = styled(BasePage)`
  > div {
    justify-content: center;
    padding-top: 0;
  }

  @media (min-width: ${theme.dimensions.breakpointsSmall + 1}px) {
    margin-top: 30px;

    #page-card {
      position: relative;
      padding-top: 80px;

      > div {
        margin: unset;
        padding: unset;
      }
    }
  }
`

export const ContentContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-grow: 1;
  flex-direction: column;

  @media (min-width: ${theme.dimensions.breakpointsSmall + 1}px) {
    max-width: 340px;
    margin: 0 auto 80px;
  }
`

export const ImageContainer = styled.div`
  max-height: 140px;
  height: 140px;
  margin: 0 auto;

  img {
    height: 100%;
  }
`

export const FooterContainer = styled.div`
  position: absolute;
  bottom: 20px;
  text-align: center;
  left: 30px;
  right: 30px;
`

export const FooterTextContainer = styled.span`
  font-style: italic;
  color: ${theme.colors.primaryStone};
  font-size: 12px;
  line-height: 16px;
`
